let appUtil = {};

// 组合路径，拼接menus中的连接到底层的所有路由
appUtil.combinationPath = function (menus, parentPath = '') {
  let paths = new Array();
  for (let key in menus) {
    let menu = menus[key];
    let currentPath = (parentPath == '' ? '' : (parentPath + '/')) + menu.path;

    if (typeof menu.children !== 'undefined' && menu.children.length != 0) {
      let subPath = appUtil.combinationPath(menu.children, currentPath);

      paths = paths.concat(subPath);
    } else {
      paths.push(currentPath);
    }
  }
  return paths;
};

// 拆分路径，如/a/b/c为[/a,/a/b,/a/b/c]
appUtil.decompoundPath = function (path) {
  let arr = path.split("/");

  // 删除第一个空字符
  let paths = [];
  let parentPath = '';
  for (let i = 1; i < arr.length; i++) {
    parentPath = parentPath + '/' + arr[i];
    paths.push(parentPath);
  }

  return paths
};

appUtil.searchPath = function (paths, routers) {
  let newRouters = [];
  if (paths.length == 0) {
    return newRouters;
  }

  let currentPath = paths[0];
  for (let router of routers) {
    if (currentPath == router.path || ('/' + currentPath) == router.path || (currentPath + '/') == router.path) {
      if (paths.length > 1) {
        let newRouter = {
          name: router.name,
          path: router.path,
          title: router.title
        };
        newRouters.push(newRouter);

        let subRouters = paths.slice(1);
        let sonPaths = appUtil.searchPath(subRouters, router.children);
        newRouters = newRouters.concat(sonPaths);
      } else {
        let newRouter = {
          name: router.name,
          path: router.path,
          title: router.title
        };

        newRouters.push(newRouter);
      }

      break;
    }
  }

  return newRouters
};

export default appUtil;



// WEBPACK FOOTER //
// ./src/store/modules/appUtil.js